import type { PrivacyPolicyConfiguration } from 'legal/types/featureFlag'

import { PRIVACY_POLICY_CONFIGURATIONS } from '../../constants/privacyPolicyConfiguration'

type PrivacyPolicyVariationsProps = {
	isInCheckout: boolean
	privacyPolicyConfiguration: PrivacyPolicyConfiguration
}

const isVariation1 = ({
	isExpandable,
	isCheckbox,
	isAboveButton,
	pdf,
}: NonNullable<PrivacyPolicyConfiguration['variables']>) =>
	!pdf?.enabled && isAboveButton && !isCheckbox && !isExpandable

const isVariation2 = ({
	isExpandable,
	isCheckbox,
	isAboveButton,
	pdf,
}: NonNullable<PrivacyPolicyConfiguration['variables']>) =>
	!pdf?.enabled && isAboveButton && isCheckbox && isExpandable

const isVariation3 = ({
	isExpandable,
	isCheckbox,
	isAboveButton,
	pdf,
}: NonNullable<PrivacyPolicyConfiguration['variables']>) =>
	pdf?.enabled && isAboveButton && isCheckbox && !isExpandable

export const privacyPolicyVariationsBase = ({
	isInCheckout,
	privacyPolicyConfiguration: { enabled, variables },
}: PrivacyPolicyVariationsProps): PRIVACY_POLICY_CONFIGURATIONS => {
	if (!enabled || !variables) {
		return PRIVACY_POLICY_CONFIGURATIONS.DISABLED
	}

	if (isVariation1(variables)) {
		if (isInCheckout) {
			return PRIVACY_POLICY_CONFIGURATIONS.DEFAULT
		}

		return PRIVACY_POLICY_CONFIGURATIONS.VARIATION_1
	}

	if (isVariation2(variables)) {
		return PRIVACY_POLICY_CONFIGURATIONS.VARIATION_2
	}

	if (isVariation3(variables)) {
		return PRIVACY_POLICY_CONFIGURATIONS.VARIATION_3
	}

	return PRIVACY_POLICY_CONFIGURATIONS.DEFAULT
}
